import type {
  NooLoginResultOtpPending,
  NooLoginResultPendingReview,
  NooLoginResultResumeRegistration,
} from './buyer-login-incomplete-types';

interface RawRegistrationIncompleteData {
  code?: string;
  registration?: {
    registration_id?: string;
    status?: string;
  };
  registration_token?: string;
}

export type BuyerLoginIncompleteResult =
  | NooLoginResultPendingReview
  | NooLoginResultResumeRegistration
  | NooLoginResultOtpPending;

function extractRegistrationIncompleteData(body: unknown): RawRegistrationIncompleteData | null {
  if (!body || typeof body !== 'object') {
    return null;
  }

  const record = body as RawRegistrationIncompleteData & { data?: unknown };

  if (record.code === 'REGISTRATION_INCOMPLETE') {
    return record;
  }

  if (record.data && typeof record.data === 'object') {
    const nested = record.data as RawRegistrationIncompleteData;
    if (nested.code === 'REGISTRATION_INCOMPLETE') {
      return nested;
    }
  }

  return null;
}

export function parseBuyerLoginIncompleteResponse(
  body: unknown,
  email: string,
): BuyerLoginIncompleteResult | null {
  const record = extractRegistrationIncompleteData(body);
  if (!record) {
    return null;
  }

  const registrationId = record.registration?.registration_id;
  const registrationStatus = record.registration?.status;

  if (
    registrationStatus === 'otp_verified' &&
    typeof registrationId === 'string' &&
    typeof record.registration_token === 'string'
  ) {
    return {
      kind: 'resume_registration',
      registration_id: registrationId,
      registration_token: record.registration_token,
      registration_status: 'otp_verified',
      email,
    };
  }

  if (registrationStatus === 'pending_review' && typeof registrationId === 'string') {
    if (typeof record.registration_token !== 'string' || record.registration_token.length === 0) {
      return null;
    }

    return {
      kind: 'pending_review',
      message: 'Registrasi Anda sedang ditinjau',
      email,
      registration_token: record.registration_token,
    };
  }

  if (registrationStatus === 'otp_pending' && typeof registrationId === 'string') {
    return {
      kind: 'otp_pending',
      registration_id: registrationId,
      email,
    };
  }

  return null;
}
